import { useEffect, useState } from 'react'
import { initializePaddle } from '@paddle/paddle-js'
import { handleError } from '@/services/errorHandler.js'
import { PADDLE_ENVIRONMENT, PADDLE_TOKEN } from '@/config-global.jsx'

export const usePaddle = (eventsHandler) => {
    const [paddleClient, setPaddleClient] = useState(null)

    const initPaddle  = async () => {
        try {

            const paddleInstance = await initializePaddle({
                environment: PADDLE_ENVIRONMENT,
                token: PADDLE_TOKEN,
                eventCallback: eventsHandler,
            })
            if (!paddleInstance) {
                throw new Error('Paddle instance not initialized')
            }

            setPaddleClient(paddleInstance)

        } catch (e) {
            handleError(e)
            console.error("Init Paddle Failed")
            console.log(e.message)
        }

    }

    useEffect(() => {
        initPaddle()
    }, [])



    return paddleClient

}

